import { createSelector } from 'reselect';

import { PpeType } from 'constants/company';
import { ppeTypesOptions } from 'constants/options';

import { selectIsBrokerCompany } from 'store/auth/selectors';

import { getSystem } from './system.selectors';

export const selectPricingConfiguration = createSelector(
  getSystem,
  ({ pricingConfiguration }) => pricingConfiguration,
);

export const selectCompanyPpeType = createSelector(
  selectPricingConfiguration,
  ({ ppeType }) => ppeType,
);

export const selectFilteredPpeTypesOptions = createSelector(
  selectIsBrokerCompany,
  isBrokerCompany =>
    ppeTypesOptions.filter(({ value }) => !(isBrokerCompany && value === PpeType.LENDER_PPE)),
);
